import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface QueryLimitProps {
  value: number | undefined;
  editable: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function QueryLimit({ value, editable, onChange }: QueryLimitProps) {
  const tooltipContent = 'Dictates the maximum number of results to retrieve';

  if (editable) {
    return (
      <div className="flex items-center gap-2">
        <Tooltip title={tooltipContent}>
          <label
            htmlFor="query-limit"
            className="text-chariot-text-secondary text-sm"
          >
            Limit:
          </label>
        </Tooltip>
        <input
          id="query-limit"
          type="number"
          min="0"
          value={value ?? ''}
          onChange={onChange}
          placeholder="No limit"
          className="bg-chariot-background-secondary text-chariot-text-primary border-chariot-stroke focus:border-chariot-brand-primary w-24 rounded-md border px-2 py-1 text-sm outline-hidden"
          data-testid="query-header-limit-input"
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Tooltip title={tooltipContent}>
        <span className="text-chariot-text-secondary text-sm">Limit:</span>
      </Tooltip>
      <span className="text-chariot-text-primary text-sm">
        {value ?? 'No limit'}
      </span>
    </div>
  );
}
